import React from 'react';
import { ServicesSection } from '../components/ServicesSection';
export function ProductsPage() {
  return <div className="pt-28" data-id="element-810">
      <ServicesSection data-id="element-811" />
    </div>;
}